/**
 * cardImageUrl — pure helper for building TCGplayer card image URLs.
 * Kept separate from CardImage.tsx so non-component consumers (slab adapters,
 * etc.) can import it without tripping the react-refresh component-only rule.
 */

/** Build the TCGplayer CDN image URL for a product id at a fit-in size. */
export function tcgplayerCdnUrl(productId: number, w = 400, h = 560): string {
  return `https://product-images.tcgplayer.com/fit-in/${w}x${h}/${productId}.jpg`;
}
